/**
 * Constants
 */
import {TokuisakiDocument} from "./interface/tokuisakiDocument";
import {User} from "./interface/userDocument";
import {CommonService} from "../core/service/common.service";
import {Timestamp} from "./type/timestamp";
import {SideMenu} from "./interface/sideMenu";
const commonService = new CommonService();

//#region important words

export const ABSTRACT: 'abstract' = 'abstract';
export const TOKUISAKI: 'tokuisaki' = 'tokuisaki';
export const USERS: 'users' = 'users';
export const NOUHINSHO: 'nouhinsho' = 'nouhinsho';
export const SEIKYUUSHO: 'seikyuusho' = 'seikyuusho';
export const NOUHIN_SEIKYUUSHO: 'nouhinSeikyuusho' = 'nouhinSeikyuusho';
export const TENPU: 'tenpu' = 'tenpu';

//#endregion

//#region collection name

export const COLLECTION_NAME: {
  ABSTRACT: 'abstract', // root collection
  USERS: 'users', // root collection
  TOKUISAKI: 'tokuisaki', // root collection
  NOUHINSHO: 'nouhinsho',
  SEIKYUUSHO: 'seikyuusho',
  NOUHIN_SEIKYUUSHO: 'nouhinSeikyuusho',
  TENPU: 'tenpu',
  NOUHINSHO_OR_SEIKYUUSHO: (denpyouNumber: string) => string
} = {
  ABSTRACT: ABSTRACT, // root collection
  USERS: USERS, // root collection
  TOKUISAKI: TOKUISAKI, // root collection
  NOUHINSHO: NOUHINSHO,
  SEIKYUUSHO: SEIKYUUSHO,
  NOUHIN_SEIKYUUSHO: NOUHIN_SEIKYUUSHO,
  TENPU: TENPU,
  NOUHINSHO_OR_SEIKYUUSHO: (denpyouNumber) => {
    return commonService.isNouhinsho(denpyouNumber) ? NOUHINSHO :
      commonService.isSeikyuusho(denpyouNumber) ? SEIKYUUSHO :
        '';
  }
};

//#endregion

//#region objectProperties

export const ABSTRACT_PROPERTIES: {
  LAST_UPDATED: 'lastUpdated',
  LIST: 'list'
} = {
  LAST_UPDATED: 'lastUpdated',
  LIST: 'list'
};

export const TOKUISAKI_PROPERTIES: {
  ID: 'id',
  NAME: 'name',
  ADMIN_USERS: 'adminUsers',
  USERS: 'users',
  NOUHINSHO_SOUFU_ADDRESS_LIST: 'nouhinshoSoufuAddressList',
  SEIKYUUSHO_SOUFU_ADDRESS_LIST: 'seikyuushoSoufuAddressList',
  DENSHI_HAKKOU_FLAG: 'denshiHakkouFlag',
  INCOMPLETE: 'incomplete',
} = {
  ID: 'id',
  NAME: 'name',
  ADMIN_USERS: 'adminUsers',
  USERS: 'users',
  NOUHINSHO_SOUFU_ADDRESS_LIST: 'nouhinshoSoufuAddressList',
  SEIKYUUSHO_SOUFU_ADDRESS_LIST: 'seikyuushoSoufuAddressList',
  DENSHI_HAKKOU_FLAG: 'denshiHakkouFlag',
  INCOMPLETE: 'incomplete',
};

export const USER_PROPERTIES: {
  NAME: 'name',
  MAIL: 'mail',
  CUSTOMER_ADMIN: 'customerAdmin',
  PERMITTED: 'permitted',
  NABEL_ADMIN: 'nabelAdmin',
  ALLOWED: 'allowed'
} = {
  NAME: 'name',
  MAIL: 'mail',
  CUSTOMER_ADMIN: 'customerAdmin',
  PERMITTED: 'permitted',
  NABEL_ADMIN: 'nabelAdmin',
  ALLOWED: 'allowed'
};

export const NOUHIN_SEIKYUUSHO_PROPERTIES:{
  DENPYOU_NUMBER: "denpyouNumber",
  TOKUISAKI_NUMBER: "tokuisakiNumber",
  STORAGE_PATH: "storagePath",
  STATUS: "status",
  DATE: "date",
  SEIKYUU_KINGAKU: "seikyuuKingaku",
  IS_DELETED: "isDeleted",
  SOUFUSAKI_NAME: "soufuSakiName",
  SOUFUSAKI_YUUBINBANGOU: "soufuSakiYuubinBangou",
  SOUFUSAKI_JUUSHO: "soufuSakiJuusho",
  SOUFUSAKI_DENWABANGOU: "soufuSakiDenwaBangou",
  SOUFUSAKI_FAXBANGOU: "soufuSakiFaxBangou",
} = {
  DENPYOU_NUMBER: "denpyouNumber",
  TOKUISAKI_NUMBER: "tokuisakiNumber",
  STORAGE_PATH: "storagePath",
  STATUS: "status",
  DATE: "date",
  SEIKYUU_KINGAKU: "seikyuuKingaku",
  IS_DELETED: "isDeleted",
  SOUFUSAKI_NAME: "soufuSakiName",
  SOUFUSAKI_YUUBINBANGOU: "soufuSakiYuubinBangou",
  SOUFUSAKI_JUUSHO: "soufuSakiJuusho",
  SOUFUSAKI_DENWABANGOU: "soufuSakiDenwaBangou",
  SOUFUSAKI_FAXBANGOU: "soufuSakiFaxBangou",
};

export const CUSTOM_CLAIM_PROPERTIES: {
  NABEL_ADMIN: 'nabelAdmin',
  CUSTOMER_ADMIN: 'customerAdmin',
  PERMITTED: 'permitted',
  ALLOWED: 'allowed',
  PASSWORD_UPDATED: 'passwordUpdated'
} = {
  NABEL_ADMIN: 'nabelAdmin',
  CUSTOMER_ADMIN: 'customerAdmin',
  PERMITTED: 'permitted',
  ALLOWED: 'allowed',
  PASSWORD_UPDATED: 'passwordUpdated'
};

export const ALLOWED_PROPERTIES: {
  NOUHIN_SEIKYUUSHO: 'nouhinSeikyuusho',
  MEMBER: 'member'
} = {
  NOUHIN_SEIKYUUSHO: 'nouhinSeikyuusho',
  MEMBER: 'member'
}

export const PERMISSION_PROPERTIES: {
  READ: 'read',
  WRITE: 'write'
} = {
  READ: 'read',
  WRITE: 'write'
}

export const TIMESTAMP_PROPERTIES: {
  SECONDS: 'seconds',
  NANOSECONDS: 'nanoseconds'
} = {
  SECONDS: 'seconds',
  NANOSECONDS: 'nanoseconds'
}

//#endregion

//#region initialValues

const A = ABSTRACT_PROPERTIES;
const T = TOKUISAKI_PROPERTIES;
const U = USER_PROPERTIES;
const TS = TIMESTAMP_PROPERTIES;

export const USER_TEMPLATE: User = {
  [U.NAME]: '',
  [U.MAIL]: '',
};

export const TOKUISAKI_TEMPLATE: TokuisakiDocument = {
  [T.ID]: '',
  [T.NAME]: ''
};

export const ADMIN_AND_USERS_TEMPLATE = {
  [T.ADMIN_USERS]: [],
  [T.USERS]: [],
};

export const TIMESTAMP_TEMPLATE: Timestamp = {
  [TS.SECONDS]: 0,
  [TS.NANOSECONDS]: 0
}

//#endregion

//#region regular expressions

// export const EMAIL_REG = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
export const EMAIL_REG = /^[\w!#$%&'*+\/=?^_`{|}~-]+(.[\w!#$%&'*+\/=?^_`{|}~-]+)*@([\w_\-.])+\.([A-Za-z]{2,4})$/;
export const USABLE_STRING_FOR_PASSWORD = "[\\w\\s!\"#$%&'()\\-=^~|@`\\[{;+:*\\]},<.>/?_]+"
export const UNUSABLE_STRING_FOR_PASSWORD_REG = /[^\w\s!"#$%&'()\-=^~|@`\[{;+:*\]},<.>/?_]+/;

export const NOUHINSHO_NUMBER_REG = /^\d+$/;
export const SEIKYUUSHO_NUMBER_REG = /^\d+-[A-Z]$/;

//#endregion

//#region symbols

export const BLANK = '';
export const HYPHEN = '-';
export const UNDER_BAR = '_';
export const SLASH = '/';
export const DOT = '.';
export const DOT_PDF = '.pdf';

//#endregion

//#region menu, itemization

export const MENU_LIST:(isCustomerAdmin: boolean, isNabelAdmin: boolean) => SideMenu[] =
  (a, b) => [
    {
      title: '納品書・請求書',
      link: '/statement',
      svg: 'statement',
      hidden: false,
    },
    {
      title: 'メンバー権限',
      link: '/member',
      icon: 'people',
      hidden: !a && !b,
    },
    {
      title: 'ヘルプ',
      link: '/help',
      icon: 'help_center',
      hidden: false,
    },
  ];

export const PREFACE_SECURITY_POLICY =
  '株式会社ナベル（以下「当社」といいます）では、情報の適切な管理が最重要課題であることを認識し、' +
  'ご利用される皆さまの情報を厳密に取り扱うとともに、漏えいリスクなどに対して、適切な防御措置を講じることにより、' +
  '信頼を得るよう努めてまいります。 ' +
  'セキュリティに関する当社の取り組み方針として「情報セキュリティ基本方針（セキュリティポリシー）」を以下の通り定め、' +
  '「情報セキュリティ基本方針（セキュリティポリシー）」および「 個人情報保護方針（プライバシーポリシー） 」を順守します。'

export const PREFACE_PRIVACY_POLICY =
  '株式会社ナベル（以下，「当社」といいます。）は、個人情報の重要性を認識し、' +
  '個人情報を保護することが社会的責務であると考え、個人情報に関する法令及び社内規定等を遵守し、' +
  '当社で取扱う個人情報の取得、利用、管理を適正に行います。';

export const SECURITY_POLICY = [
  {
    heading: '第1条（目的）',
    body: '本情報セキュリティ基本方針は、社内外、故意又は偶然の全ての脅威からお客様並びに弊社の情報資産を保護し、' +
      '安定した事業活動を継続することを目的として、情報セキュリティの基本方針として定めます。'
  },
  {
    heading: '第2条（適用範囲）',
    body: '本基本方針は当社が事業活動の中で取扱う「情報資産」を対象とします。情報資産とは、当社が保有または運用管理する情報、' +
      'データ及び情報システム、ネットワーク、設備とし、有形、無形に関わらず、事業を展開する中で当社が必要と判断する全てのものを対象とします。'
  },
  {
    heading: '第3条（情報セキュリティ体制の構築）',
    body: '当社は、経営陣を中心として情報セキュリティマネジメントシステムの体制を整え、情報セキュリティの維持、' +
      '向上の取組みを行うものとします。また、これらの取組みを定期的に監査し、改善に努める体制を整備します。'
  },
  {
    heading: '第4条（情報資産の保護）',
    body: '当社は、保有する全ての情報資産を機密性、完全性、可用性の視点から重要性を認識するとともにリスク評価を行い、' +
      '情報セキュリティ体制のもと適切な情報資産の保護に努めます。'
  },
  {
    heading: '第5条（情報セキュリティリテラシーの向上）',
    body: '当社は、全従業者に対して、情報セキュリティリテラシーの向上を図るとともに、' +
      '当社の情報資産の適切な管理を実行するための教育・訓練を継続的に実施します。'
  },
  {
    heading: '第6条（セキュリティ事件・事故の対応）',
    body: '当社は、セキュリティ事件・事故が発生した場合、またはその予兆があった場合、速やかな対応及び手続きを行います。'
  },
  {
    heading: '第7条（法令・規制・契約事項等の遵守）',
    body: '事業推進上で適用される法令・規制・契約事項を、その都度、把握して遵守します。'
  },
  {
    heading: '第8条（事業継続管理）',
    body: '偶発的に発生する情報システムの災害・故障・過失及び意図的に発生する情報資産の悪用などによる事業の中断を可能な限り抑え、' +
      '事業の継続を確保していきます。'
  },
  {
    heading: '第9条（本基本方針違反に対する措置）',
    body: '当社の社員は、本基本方針に従って行動することとし、違反した場合は、就業規則に基づき懲戒の対象とします。'
  },
  {
    heading: '第10条（継続的改善の実施）',
    body: '当社は、以上の取り組みを定期的に評価、見直すことにより、情報セキュリティ管理の継続的改善を実施します。'
  },
];

export const  PRIVACY_POLICY = [
  {
    heading: '第1条（適用範囲）',
    body: '本プライバシーポリシー（以下、「本ポリシー」といいます。）は、' +
      '本ウェブサイトで提供するサービス（以下、「本サービス」といいます。）において、' +
      'ユーザーの個人情報もしくはそれに準ずる情報を取り扱う際に、当社が遵守する方針を示したものです。'
  },
  {
    heading: '第2条（個人情報の取得）',
    body: '当社は、本サービスの提供に必要な範囲で、ユーザーに個人情報をご提供いただく場合があります。'
  },
  {
    heading: '第3条（利用目的）',
    body: '当社は、当社が取得した個人情報について、法令に定める場合又は本人の同意を得た場合を除き、以下に定める利用目的の達成に必要な範囲を超えて利用することはありません。\n' +
      '\n' +
      '　１．本サービスの提供、運営\n' +
      '　２．ユーザーからのお問い合わせに回答するため\n' +
      '　３．本サービスの利用に伴う連絡、各種お知らせ等の案内のため\n' +
      '　４．利用規約等で禁じている行為などの調査のため'
  },
  {
    heading: '第4条（個人情報の提供等）',
    body: '当社は、ユーザーの個人情報を第三者に提供することはありません。また、今後第三者提供を行う事になった場合には、提供する情報と提供目的などを提示し、ユーザーから同意を得た場合のみ第三者提供を行います。'
  },
  {
    heading: '第5条（お問い合わせ窓口）',
    body: '本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。\n' +
      '\n' +
      '株式会社ナベル 個人情報取扱い担当\n' +
      '〒601-8444 京都市南区西九条森本町86番地\n' +
      'TEL:(075)693-5301 FAX:(075)693-5302\n' +
      'Mail:nabel@mail.nabel.co.jp'
  },
];

//#endregion

//#region others

export const DIALOG_WIDTH = window.innerWidth >= 600 ? '600px' : (window.innerWidth) + 'px'

export const ADDRESS_LIST_NAMES: ('nouhinshoSoufuAddressList' | 'seikyuushoSoufuAddressList')[] = [
  TOKUISAKI_PROPERTIES.NOUHINSHO_SOUFU_ADDRESS_LIST,
  TOKUISAKI_PROPERTIES.SEIKYUUSHO_SOUFU_ADDRESS_LIST,
];

/**
 * DialogComponentを呼び出す際のボタンオプション
 */
export const CONFIRM_OPTIONS = {
  ok: [
    {label: 'OK', color: 'primary', returnValue: true}
  ],
  okCancel: [
    {label: 'キャンセル', color: 'warn', returnValue: false},
    {label: 'OK', color: 'primary', returnValue: true},
  ],
};

export const logError = (e: any) => console.error(e);

//#endregion

export const TN_LIST = [
"01041",
"01053",
"01055",
"01060",
"01061",
"01063",
"01066",
"01069",
"02001",
"02023",
"02026",
"02039",
"02048",
"02050",
"02056",
"03001",
"03008",
"03025",
"04007",
"04045",
"05008",
"05011",
"05012",
"05046",
"05047",
"06010",
"07001",
"08001",
"08006",
"08033",
"08035",
"08042",
"08060",
"08061",
"08072",
"08080",
"08096",
"08098",
"09025",
"09031",
"10001",
"10002",
"10003",
"10004",
"10010",
"10012",
"10015",
"10016",
"10024",
"10036",
"10039",
"10056",
"10066",
"10067",
"11003",
"11025",
"11038",
"11041",
"11042",
"11056",
"11057",
"11066",
"11085",
"12003",
"12010",
"12038",
"12042",
"12047",
"12050",
"12052",
"12056",
"12069",
"12071",
"12075",
"12088",
"12095",
"12106",
"12108",
"12111",
"12113",
"12116",
"12117",
"13001",
"13002",
"13066",
"13096",
"13097",
"14001",
"14002",
"14007",
"14009",
"14035",
"14038",
"15091",
"16005",
"16007",
"16018",
"16030",
"16035",
"16037",
"17004",
"17015",
"18005",
"18019",
"19001",
"20018",
"20027",
"20029",
"21004",
"21012",
"21023",
"21030",
"21035",
"21040",
"21041",
"21054",
"22001",
"22016",
"22032",
"22046",
"22058",
"22061",
"23023",
"23055",
"23065",
"23070",
"23077",
"23084",
"23090",
"23091",
"23096",
"23098",
"23115",
"23120",
"23154",
"23156",
"23161",
"23164",
"23181",
"23183",
"23191",
"24001",
"24041",
"24045",
"24062",
"24064",
"24065",
"24066",
"24075",
"24083",
"24086",
"24087",
"25019",
"26018",
"26063",
"27020",
"27051",
"28007",
"28010",
"28050",
"28067",
"28071",
"28084",
"28089",
"28107",
"28109",
"29014",
"29017",
"30009",
"31002",
"31014",
"31017",
"32007",
"33001",
"33035",
"33068",
"33074",
"33094",
"33098",
"34003",
"34004",
"34013",
"34044",
"34047",
"34051",
"34062",
"34063",
"34068",
"35010",
"35012",
"35015",
"35019",
"35028",
"36009",
"36014",
"37001",
"37023",
"37030",
"37040",
"37054",
"37060",
"37070",
"38009",
"38022",
"38024",
"39007",
"39019",
"40009",
"40025",
"40027",
"40034",
"40041",
"40089",
"40091",
"40092",
"40118",
"40122",
"40124",
"41005",
"41028",
"41029",
"42013",
"42014",
"43020",
"43021",
"43023",
"43025",
"43026",
"43028",
"43045",
"43054",
"43056",
"43058",
"44003",
"44015",
"44020",
"44022",
"44034",
"45008",
"45019",
"45032",
"45045",
"45053",
"46003",
"46015",
"46024",
"46031",
"46045",
"46054",
"46061",
"46077",
"46079",
"46091",
"46094",
"47001",
"47004",
"47007",
"47012",
"47016"]
